import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  TExpirationDate,
  TFormActions,
} from '../../../reducers/formStateReducer';
import { ExpirationDate } from '../../ExpirationDate';
import { isFieldEmpty, validateExpirationField } from '../validators';

export const ExpirationField: React.FC<{
  setState: React.Dispatch<TFormActions>;
  value: TExpirationDate;
}> = ({ setState, value: expirationField }) => {
  const { t } = useTranslation();

  const validateField = () =>
    !isFieldEmpty('expirationDate', expirationField) &&
    !validateExpirationField(expirationField)
      ? setState({
          type: 'fieldError',
          value: { fieldName: 'expirationDate', hasError: true },
        })
      : setState({
          type: 'fieldError',
          value: { fieldName: 'expirationDate', hasError: false },
        });

  return (
    <ExpirationDate
      dataHook="expiration-date"
      status={expirationField.hasError ? 'error' : undefined}
      onBlur={validateField}
      statusMessage={t(
        'charge-locator.charge_locator_form.field_error.invalid_expiration_date',
      )}
      value={expirationField}
      onChange={(e) => setState({ type: 'expirationDate', value: e })}
      label={t('charge-locator.charge-locator-form.expiration')}
    />
  );
};
